import { __decorate } from "tslib";
import { AutoEncoder, DateDecoder, StringDecoder, field } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { Group } from '../Group.js';
import { AuditLogReplacement } from '../AuditLogReplacement.js';
export class MemberResponsibilityRecordBase extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.organizationId = null;
        this.groupId = null;
        this.startDate = new Date();
        this.endDate = null;
    }
    get isActive() {
        return this.startDate <= new Date() && (this.endDate === null || this.endDate > new Date());
    }
    getDiffName() {
        return AuditLogReplacement.uuid(this.responsibilityId);
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], MemberResponsibilityRecordBase.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberResponsibilityRecordBase.prototype, "memberId", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], MemberResponsibilityRecordBase.prototype, "organizationId", void 0);
__decorate([
    field({ decoder: StringDecoder, nullable: true })
], MemberResponsibilityRecordBase.prototype, "groupId", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberResponsibilityRecordBase.prototype, "responsibilityId", void 0);
__decorate([
    field({ decoder: DateDecoder })
], MemberResponsibilityRecordBase.prototype, "startDate", void 0);
__decorate([
    field({ decoder: DateDecoder, nullable: true })
], MemberResponsibilityRecordBase.prototype, "endDate", void 0);
export class MemberResponsibilityRecord extends MemberResponsibilityRecordBase {
    constructor() {
        super(...arguments);
        this.group = null;
    }
    getName(member, includeOrganization = true) {
        let allResponsibilities = member.family.platform.config.responsibilities;
        let suffix = (this.group ? ' ' + $t(`%wR`) + ' ' + this.group.settings.name : '');
        if (this.organizationId) {
            const organization = member.family.getOrganization(this.organizationId);
            if (organization && organization.privateMeta) {
                allResponsibilities = [...allResponsibilities, ...organization.privateMeta.responsibilities];
            }
            if (organization && includeOrganization) {
                suffix += ' ' + $t(`%i0`) + ' ' + organization.name;
            }
        }
        const responsibility = allResponsibilities.find(r => r.id == this.responsibilityId);
        return (responsibility ? responsibility.name : $t(`%qZ`)) + suffix;
    }
}
__decorate([
    field({ decoder: Group, nullable: true, version: 328 })
], MemberResponsibilityRecord.prototype, "group", void 0);
//# sourceMappingURL=MemberResponsibilityRecord.js.map